module.exports = __webpack_public_path__ + "assets/img/cp.6e96755a.png";